<hr>
<div class="grid">
  <div class="col-12">
    <span class="section-title mt-3" translate>payment_detail_bill_to_label</span>
  </div>
  <div class="col-3">
    <label>{{ 'payment_detail_company_label' | translate }}:</label><br>
    <span class="field-value">{{ billTo.companyName }}</span>
  </div>
  <div class="col-3">
    <label>{{ 'payment_detail_address_label' | translate }}:</label><br>
    <span class="field-value">{{ billTo.address }}</span>
  </div>
  <div class="col-3">
    <label>{{ 'payment_detail_city_label' | translate }}:</label><br>
    <span class="field-value">{{ billTo.cityName }}</span>
  </div>
  <div class="col-3">
    <label>{{ 'payment_detail_tax_number_label' | translate }}:</label><br>
    <span class="field-value">{{ billTo.taxId }}</span>
  </div>
  <div class="col-3">
    <label>{{ 'payment_detail_zip_code_label' | translate }}:</label><br>
    <span class="field-value">{{ billTo.postalCode }}</span>
  </div>
  <div class="col-3">
    <label>{{ 'payment_detail_country_label' | translate }}:</label><br>
    <span class="field-value">{{ billTo.countryIso }}</span>
  </div>
</div>